export interface SortConfig {
  column: string;
  order: 'asc' | 'desc';
}

/**
 * Configuration options for the table display and pagination
 */
export interface TableOptions {
  /** Column headers for the table */
  heading: string[];
  /** Available options for items per page */
  itemsPerPageList: number[];
  /** Current number of items per page */
  itemsPerPage: number;
  /** Total number of items (optional) */
  numberOfItems?: number;
  /** Whether the table is in loading state */
  isLoading?: boolean;
  /** Whether there was an error loading data */
  hasLoadingError?: boolean;
  /** Whether to show empty state */
  hasEmptyState?: boolean;
  /** Custom subtitle for the empty state (omit to hide subtitle) */
  emptyStateSubtitle?: string;
  /** Optional width for each column (e.g. ['50%', '20%', '20%', '10%']) */
  columnWidths?: string[];
  /** Data keys for each column — enables sort when combined with onSortChange */
  columnKeys?: string[];
  /** Current sort state */
  sortConfig?: SortConfig;
  /** Called with the column key when a sortable header is clicked */
  onSortChange?: (columnKey: string) => void;
  /** Overrides the default white background on table and pagination row */
  backgroundColor?: string;
  minHeight?: string;
  /** Set the automatic height based on the number of lines per page. */
  isAutoHeight?: boolean;
}

/**
 * Props for the TableWithPagination component
 */
export interface TableWithPaginationProps {
  /** Table configuration options */
  options: TableOptions;
  /** Table content (rows) */
  children?: React.ReactNode;
  /** Callback fired when pagination changes */
  onPaginationChange?: (event: CustomEvent) => void;
  /** Callback fired when items per page changes */
  onItemsPerPageChange?: (event: CustomEvent) => void;
  /** Callback for refreshing data on error state */
  onRefreshData?: () => void;
}

export const DEFAULT_STARTED_PAGE = 1;
